import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@sfcu/sfc-front-starter';

@Injectable({
    providedIn: 'root',
})
export class HostnameService {

    constructor(@Inject(WINDOW) private window: Window) {
    }

    isRed(): boolean {
        let currentHostname = this.window.location?.hostname;
        return currentHostname?.includes('red') ?? false;
    }

    isFut(): boolean {
        let currentHostname = this.window.location?.hostname;
        return currentHostname?.includes('futpsw') ?? false;
    }

    isPfv(): boolean {
        let currentHostname = this.window.location?.hostname;
        return <boolean>currentHostname?.includes('pfv') ?? false;
    }

    isCms(): boolean {
        let currentHostname = this.window.location?.hostname;
        return currentHostname?.includes('cms') ?? false;
    }

    monEspaceClientUrl(): string {

        type EnvironmentKey = 'default' | 'cms' | 'fut' | 'pfv';

        interface linkConfig {
            red: string;
            default: string;
        }

        const espaceClientConfig: Record<EnvironmentKey, linkConfig> = {
            default: {
                red: 'https://www.red-by-sfr.fr/mon-espace-client/',
                default: 'https://espace-client.sfr.fr/mon-espace-client/'
            },
            cms: {
                red: 'https://cms.red-by-sfr.fr/mon-espace-client/',
                default: 'https://cms.sfr.fr/mon-espace-client/'
            },
            fut: {
                red: 'https://futpsw.red-by-sfr.fr/mon-espace-client/',
                default: 'https://futpsw.sfr.fr/mon-espace-client/'
            },
            pfv: {
                red: 'https://www.pfv.red-by-sfr.fr/mon-espace-client/',
                default: 'https://www.pfv.sfr.fr/mon-espace-client/'
            }
        };

        const getEnvironmentKey = (): EnvironmentKey => {
            if (this.isCms()) {
                return 'cms';
            } else if (this.isFut()) {
                return 'fut';
            } else if (this.isPfv()) {
                return 'pfv';
            } else {
                return 'default';
            }
        };

        const environmentKey = getEnvironmentKey();
        const ec = espaceClientConfig[ environmentKey ];
        return this.isRed() ? ec.red : ec.default;
    }
    espaceClientBaseUrl(profil : 'red' | 'sfr' = 'sfr'): string {

        type EnvironmentKey = 'default' | 'cms' | 'fut' | 'pfv';

        interface linkConfig {
            red: string;
            default: string;
        }

        const espaceClientConfig: Record<EnvironmentKey, linkConfig> = {
            default: {
                red: 'https://espace-client-red.sfr.fr/',
                default: 'https://espace-client.sfr.fr/'
            },
            cms: {
                red: 'https://cms.red-by-sfr.fr/mon-espace-client/',
                default: 'https://cms.sfr.fr/mon-espace-client/'
            },
            fut: {
                red: 'https://espace-client-red.futpsw.sfr.fr/',
                default: 'https://espace-client.futpsw.sfr.fr/'
            },
            pfv: {
                red: 'https://espace-client-red.pfv.sfr.fr/',
                default: 'https://espace-client.pfv.sfr.fr/'
            }
        };

        const getEnvironmentKey = (): EnvironmentKey => {
            if (this.isCms()) {
                return 'cms';
            } else if (this.isFut()) {
                return 'fut';
            } else if (this.isPfv()) {
                return 'pfv';
            } else {
                return 'default';
            }
        };

        const environmentKey = getEnvironmentKey();
        const ec = espaceClientConfig[ environmentKey ];
        return profil === 'red' ? ec.red : ec.default;
    }

}
